// extracted by mini-css-extract-plugin
export default {"container":"DesignGuidelines_container__Az7IR","cardContainer":"DesignGuidelines_cardContainer__43bSJ"};